import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import { timer } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LocalService } from '../../local.service';
import { LogoutService } from '../../logout/logout.service';
export class ConfirmModel {
  title: string; 
  hclass: string = 'modeldefault';
  oktext: string;
  canceltext: string;
  okshow: boolean;
  cancelshow: boolean;
}
declare var $: any;
@Component({
  selector: 'app-dialogwithtimer',
  templateUrl: './dialogwithtimer.component.html',
  styleUrls: ['./dialogwithtimer.component.css']
})
export class DialogwithtimerComponent extends DialogComponent<ConfirmModel, boolean> implements OnInit{
  title: string;
  hclass: string = 'modeldefault';
  oktext: string;
  canceltext: string;
  okshow: boolean;
  cancelshow: boolean;
  message: string;
  timeLeft: number = 120;
  subscribeTimer: any;
  interval;
  postresult: boolean;
  isSessionContinue: boolean = false;
  constructor(
    private toastr: ToastrService,
    public dialogService: DialogService,
    private router: Router ,
    private localService: LocalService,
    private logoutservice: LogoutService) {   super(dialogService);}

  confirm() {
    this.result = true;
    this.close();
    this.isSessionContinue = true;
  }
 
  startTimer() {
    const source = timer(1000, 1000);
         
    const abc = source.subscribe(val => {
              //console.log(val, '-');
              //this.subscribeTimer = this.timeLeft - val;
              this.timeLeft--;
              if(this.isSessionContinue==true)
              {
                this.timeLeft = 120;
                this.isSessionContinue = false;
                abc.unsubscribe();
              }
              console.log(this.timeLeft);
              if(this.timeLeft <= 0) {
                  abc.unsubscribe();
				  this.isSessionContinue = false;
                  this.logout();
              }
            });
            




/*
    this.interval = setInterval(() => {
      if(this.timeLeft > 0) {
        this.timeLeft--;
      }
      if(this.timeLeft<=0)
      {
        this.logout();
      } 
      console.log(this.timeLeft);
    },1000)

    */
  }

  ngOnInit() {
    // ;    
    this.message='Your session is about to expire. You will be logged out in'+ this.timeLeft +' seconds.',
    this.startTimer();
    $('#btnOK').focus();
    $('#bodyid').append('<div id="optboot" class="modal-backdrop fade in" style="opacity:0.5"></div>');
  }

  logout()
  {
    if (localStorage.getItem("LoggedIn") == null || localStorage.getItem("LoggedIn") == undefined) {
      localStorage.clear();
      
      // Clear the localStorage
      this.localService.clearToken();

      this.router.navigate(["login"]);
    }
    else {
    var logid = this.localService.getJsonValue("logid");
    var returnedid = this.logoutservice.logout(logid).subscribe(res => {
      //console.log(res);
      if (res.status == 200) {
        this.postresult = true;
        localStorage.clear();

        // Clear the localStorage
        this.localService.clearToken();

        localStorage.removeItem("LoggedIn");
        this.router.navigate(["login"]);
      };

    },
    error => {
        this.toastr.error(error.error);
        this.postresult = false
      })
    }
                  this.close();
  }
}
